import { render, staticRenderFns } from "./chargingTypeDetail.vue?vue&type=template&id=2841abb5&scoped=true"
import script from "./chargingTypeDetail.vue?vue&type=script&lang=js"
export * from "./chargingTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./chargingTypeDetail.vue?vue&type=style&index=0&id=2841abb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841abb5",
  null
  
)

export default component.exports